import { createFileRoute } from '@tanstack/react-router'
import { SettingsConnections } from '@/features/settings/connections'

export const Route = createFileRoute('/_authenticated/profile/connections')({
  component: SettingsConnections,
})
